import { useContext } from 'react';

import { AnalyticsContext } from './AnalyticsProvider';

export const useAnalytics = () => useContext(AnalyticsContext);
